// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (min-width: 200px) {
.home-title {
    width: 100%;
    font-weight: 800;
    font-size: 52px;
    line-height: 111%;
    }

    .arrow-container .left-arrow, .arrow-container .mid-arrow, .arrow-container .right-arrow{
    opacity: 0;
    }

     .arrow-container .align-items-end {
        margin-left: -10px;
     }

    .find-container {
            display: none;
        }
    .about .faceless .title {
        font-weight: 800;
        font-size: 48px;
        line-height: 117%;
    }
    .about .about-msg {
        font-weight: 400;
        font-size: 16px;
        line-height: 148%;
    }

    .about .figures .col-4 {
        width:200px;
    }
   .about .hireworkers .title {
        font-weight: 700;
        font-size: 32px;
        line-height: 125%;
    }
    .about .hireworkers .desc {
        font-weight: 500;
        font-size: 20px;
        line-height: 132%;
    }
   .about .hireworkers .title {
        font-weight: 700;
        font-size: 32px;
        line-height: 125%;
   }
    .arrow2-container {
        width: 100%;
    }

    .about .recommendation .title {
        font-weight: 700;
        font-size: 32px;
        line-height: 125%;
        padding-top: 25px;
    }
    about .recommendation .desc {
        font-weight: 400;
        font-size: 16px;
        line-height: 148%;
         width: 260px;
         height: 300px;
    }

    .about .recommendation .form {
       padding: 0;
    }
    .about .recommendation .form .title{
        font-weight: 600;
        font-size: 24px;
        line-height: 125%;
        padding: 20px;
    }
    .about .recommendation .form .inputs {
        margin-left: 33px;
    }
    .about .recommendation .form .inputs .btn-group .flag-container{
        margin-right: -35px;
    }
    .about .recommendation .form .inputs .btn-group input {
        padding-left: 40px;
    }
    .about .recommendation .form button{
        margin-left: -15px;
    }
    .about .recommendation .form .hr {
        height:25px;
    }
    .about .join .form .title{
        font-weight: 600;
        font-size: 24px;
        line-height: 125%;
    }
    .about .join .links a{
        font-weight: 600;
        font-size: 16px;
        line-height: 148%;
    }
    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {
        font-size: 20px;
    }
    .profile .profile-section .header {
        font-size: 18px;
    }
    .job-badge .job-name {
        font-size: 16px;
    }
    .user-badge .user-name {
        font-size: 18px;
    }
    .user-badge .stars img {
        width: 24px;
    }
    .profile-section.subscription img{
        width: 256px;
    }
    .avatar-container {
        width: 120px;
        height: 120px;
        position: relative;
    }
    .avatar-container .ava-cam {
        left: 37px;
        top: 37px;
    }
    .create_recommendation .characteristics .label{
        font-size: 14px;
    }
    .user-badge.big-title .user-name {
        font-weight: 800;
        font-size: 28px;
        line-height: 117%;
    }
    .recommendation .rating-gauge .label, .recommendation .rating-gauge {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/scss/media_width_200.css"],"names":[],"mappings":"AAAA;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;;IAEA;IACA,UAAU;IACV;;KAEC;QACG,kBAAkB;KACrB;;IAED;YACQ,aAAa;QACjB;IACJ;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;GACD;QACK,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;GACD;QACK,gBAAgB;QAChB,eAAe;QACf,iBAAiB;GACtB;IACC;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;SAChB,YAAY;SACZ,aAAa;IAClB;;IAEA;OACG,UAAU;IACb;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@media all and (min-width: 200px) {\n.home-title {\n    width: 100%;\n    font-weight: 800;\n    font-size: 52px;\n    line-height: 111%;\n    }\n\n    .arrow-container .left-arrow, .arrow-container .mid-arrow, .arrow-container .right-arrow{\n    opacity: 0;\n    }\n\n     .arrow-container .align-items-end {\n        margin-left: -10px;\n     }\n\n    .find-container {\n            display: none;\n        }\n    .about .faceless .title {\n        font-weight: 800;\n        font-size: 48px;\n        line-height: 117%;\n    }\n    .about .about-msg {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 148%;\n    }\n\n    .about .figures .col-4 {\n        width:200px;\n    }\n   .about .hireworkers .title {\n        font-weight: 700;\n        font-size: 32px;\n        line-height: 125%;\n    }\n    .about .hireworkers .desc {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 132%;\n    }\n   .about .hireworkers .title {\n        font-weight: 700;\n        font-size: 32px;\n        line-height: 125%;\n   }\n    .arrow2-container {\n        width: 100%;\n    }\n\n    .about .recommendation .title {\n        font-weight: 700;\n        font-size: 32px;\n        line-height: 125%;\n        padding-top: 25px;\n    }\n    about .recommendation .desc {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 148%;\n         width: 260px;\n         height: 300px;\n    }\n\n    .about .recommendation .form {\n       padding: 0;\n    }\n    .about .recommendation .form .title{\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 125%;\n        padding: 20px;\n    }\n    .about .recommendation .form .inputs {\n        margin-left: 33px;\n    }\n    .about .recommendation .form .inputs .btn-group .flag-container{\n        margin-right: -35px;\n    }\n    .about .recommendation .form .inputs .btn-group input {\n        padding-left: 40px;\n    }\n    .about .recommendation .form button{\n        margin-left: -15px;\n    }\n    .about .recommendation .form .hr {\n        height:25px;\n    }\n    .about .join .form .title{\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 125%;\n    }\n    .about .join .links a{\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 148%;\n    }\n    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {\n        font-size: 20px;\n    }\n    .profile .profile-section .header {\n        font-size: 18px;\n    }\n    .job-badge .job-name {\n        font-size: 16px;\n    }\n    .user-badge .user-name {\n        font-size: 18px;\n    }\n    .user-badge .stars img {\n        width: 24px;\n    }\n    .profile-section.subscription img{\n        width: 256px;\n    }\n    .avatar-container {\n        width: 120px;\n        height: 120px;\n        position: relative;\n    }\n    .avatar-container .ava-cam {\n        left: 37px;\n        top: 37px;\n    }\n    .create_recommendation .characteristics .label{\n        font-size: 14px;\n    }\n    .user-badge.big-title .user-name {\n        font-weight: 800;\n        font-size: 28px;\n        line-height: 117%;\n    }\n    .recommendation .rating-gauge .label, .recommendation .rating-gauge {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
